let ivoryIv = {
  "pinned": [
    "Id"
  ],
  "width": {
    "Deal": 240,
    "WireDate": 94
  },
  "immutable": {
    "Total": true,
    "CashBalance": true,
    "CKGBalance": true,
    "CoInvestCKGBalance": true,
    "Id": true,
    "RunningFRBBalCKG": true,
    "RunningFRBCoCKG": true,
    "RunningFRBTranchII": true,
    "FRBBalancedTotal": true,
    "FRBCoInvestTotal": true,
    "FRBTrancheIITotal": true,
    "LOCInterestCommitment": true
  },
  "mapping": {
    "Id": {
      "header": "Id",
      "rules": null,
      "dataType": "Int",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Id",
      "format": "text"
    },
    "Deal": {
      "header": "Deal",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Deal",
      "cellEditor": "autoCompleteCellEditor",
      "format": "text"
    },
    "WireDate": {
      "header": "Wire Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "WireDate",
      "format": "date"
    },
    "Vehicle": {
      "header": "Vehicle",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Vehicle",
      "format": "text"
    },
    "BalancedMMA": {
      "header": "Balanced MMA",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "BalancedMMA",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "CoInvestMMA": {
      "header": "Co-Invest MMA",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CoInvestMMA",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "TrancheIIMMA": {
      "header": "Tranche II MMA",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "TrancheIIMMA",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "BalancedCKG": {
      "header": "Balanced Split",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "BalSplit",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "CoInvestCKG": {
      "header": "Co-Invest Split",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CoSplit",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "TrIISplit": {
      "header": "Tranche II Split",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "TrIISplit",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "FRBBalancedCKG": {
      "header": "FRB Balanced Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FRBBalancedCKG",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "FRBCoInvestCKG": {
      "header": "FRB Co-Invest Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CoInvestCKGBalance",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "Total": {
      "header": "Total",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Total",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "CashBalance": {
      "header": "Cash Balance",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CashBalance",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "RunningFRBBalCKG": {
      "header": "Running FRB Balanced Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RunningFRBBalCKG",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "RunningFRBCoCKG": {
      "header": "Running FRB CoInvest Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RunningFRBCoCKG",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "TranchIICKG": {
      "header": "Tranche II Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "TranchIICKG",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "RunningFRBTranchII": {
      "header": "Running FRB Tranche II Checking",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RunningFRBTranchII",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    //"CKGBalance": { "header": "Balanced Checking Balance", "rules": null, "dataType": "text", "meta": null, "palceholder": null, "validations": null, "col": "CKGBalance", "textAlign": "right", "cellEditor": "agTextCellEditor", "format": "numeric" },
    "CoInvestCKGBalance": {
      "header": "Co-Invest Reimburse Balance",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CoInvestCKGBalance",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "FRBBalancedTotal": {
      "header": "Balanced Total",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FRBBalancedTotal",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "FRBCoInvestTotal": {
      "header": "Co-Invest Total",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FRBCoInvestTotal",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "FRBTranchIITotal": {
      "header": "FRB Tranche II Total",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FRBTranchIITotal",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "numeric"
    },
    "AutomatedComments": {
      "header": "Automated Comments",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AutomatedComments",
      "cellEditor": "agTextCellEditor",
      "format": "text"
    },
    "TiesToBank": {
      "header": "Ties to Bank",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "TiesToBank",
      "cellEditor": "agTextCellEditor",
      "format": "text"
    },
    "Notes": {
      "header": "Notes",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Notes",
      "cellEditor": "agTextCellEditor",
      "format": "text"
    },
    "FXRate": {
      "header": "FXRate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FXRate",
      "textAlign": "right",
      "cellEditor": "agTextCellEditor",
      "format": "text"
    },
    "FXRateDate": {
      "header": "Date of FX Rate",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FXRateDate",
      "format": "date"
    },
    "LOCInterestCommitment": {
      "header": "LOC Interest and Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "LOCInterestCommitment",
      "format": "text"
    }
  }
}
  //module.exports = ivoryIv
  export  {ivoryIv}
